import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';
import { ChevronDown, ChevronLeft, ChevronRight, Loader2 } from 'lucide-angular';

import { UtilsComponentesModule } from '../../../utils/componentes/utils-componentes.module';
import { PageTitleModule } from '../../../infrastructure/ui/components/page-title/page-title.module';
import { PlanoEnsinoComponent } from './plano-ensino.component';

@NgModule({
  declarations: [PlanoEnsinoComponent],
  imports: [
    CommonModule,
    UtilsComponentesModule,
    PageTitleModule,
    LucideAngularModule.pick({ ChevronDown, ChevronLeft, ChevronRight, Loader2 })
  ],
  exports: [PlanoEnsinoComponent]
})
export class PlanoEnsinoModule {}
